export default __webpack_public_path__ + "static/media/deleteButton.0974d4da.svg";